import LaunchPage from "./pages/LaunchPage";

function App() {
  return <LaunchPage />;
}

export default App;